import type { GoldenDataset } from "@/ai-coding-outputs/admin-coding/useGoldenDataset";
import { DropdownMenuItem, DropdownMenuLabel } from "@/components/ui/dropdown-menu";
import { useUserProfile } from "@/user/useUserProfiles";
import dayjs from "dayjs";
import { Database, Trash2 } from "lucide-react";

const SOURCE_LABELS = { ai_result: "AI result", human_review: "human review" } as const;

const GoldenDatasetNote = ({ membership }: { membership: NonNullable<GoldenDataset["membership"]> }) => {
  const { data: profiles } = useUserProfile(membership.addedBy ?? undefined);
  const addedByName = membership.addedBy ? profiles?.[membership.addedBy]?.display_name : undefined;
  const addedOn = membership.addedAt ? dayjs(membership.addedAt).format("D MMM YYYY") : undefined;
  const addedBy = [addedByName && `added by ${addedByName}`, addedOn].filter(Boolean).join(", ");
  const note = ["In golden dataset", membership.source && SOURCE_LABELS[membership.source.kind], addedBy]
    .filter(Boolean)
    .join(" · ");

  return <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">{note}</DropdownMenuLabel>;
};

export const GoldenDatasetMenuItems = ({ golden }: { golden: GoldenDataset }) => (
  <>
    {golden.offersAdd && (
      <DropdownMenuItem
        onClick={golden.add}
        disabled={golden.unavailableReason !== undefined || golden.isBusy}
        title={golden.unavailableReason}
      >
        <Database className="mr-2 h-4 w-4" />
        <span className="flex flex-col">
          {golden.addLabel}
          {golden.unavailableReason && (
            <span className="text-xs text-muted-foreground">{golden.unavailableReason}</span>
          )}
        </span>
      </DropdownMenuItem>
    )}
    {golden.membership && (
      <>
        <DropdownMenuItem onClick={golden.remove} disabled={golden.isBusy}>
          <Trash2 className="mr-2 h-4 w-4" />
          Remove from golden dataset
        </DropdownMenuItem>
        <GoldenDatasetNote membership={golden.membership} />
      </>
    )}
  </>
);
